exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title {\n  font-size: 18px;\n  font-weight: 600;\n  padding: 15px;\n  border-bottom: 1px solid #dfe1e6; }\n\n.col-left {\n  width: 50%;\n  padding-right: 7.5px; }\n\n.col-right {\n  width: 50%;\n  padding-left: 7.5px; }\n\n.booking-report-form {\n  padding: 15px; }\n\n.information {\n  font-size: 12px;\n  color: #6b778c;\n  margin: 10px 0px 30px; }\n\n.text-error {\n  font-size: 12px;\n  margin: 10px 0px 30px; }\n\n.form-group, .form-group-inline {\n  margin: 0; }\n\n@media screen and (max-width: 767px) {\n  .button-left {\n    padding-right: 10px; }\n  .button-right {\n    padding-left: 10px; }\n  .col-left {\n    padding-right: 5.5px; }\n  .col-right {\n    padding-left: 5.5px; } }\n\n.ota-loading {\n  height: 40px;\n  margin-bottom: 10px; }\n\n.ota-btn-main {\n  margin: 0px 0 15px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-booking-report/dialog-booking-report.component.scss
// module id = 907
// module chunks = 22